export const CLEAN_WEB_NOTIFICATION = 'CLEAN_WEB_NOTIFICATION';

export const cleanWebNotification = (tag) => {
    return dispatch => {
        dispatch({
            type: CLEAN_WEB_NOTIFICATION,
            tag: tag
        });
    }
}